<template>
  <button class="mypage-select-plan-button-parts" @click="handleClicked">
    <span class="mypage-select-plan-button-parts__header">
      <span class="mypage-select-plan-button-parts__title">
        <span class="mypage-select-plan-button-parts__title-name">{{ name }}</span>
        <span
          v-if="isEligibleTrialPlan"
          class="mypage-select-plan-button-parts__title-price-show-on-trial"
          >{{ priceShowOnTrial }}</span
        >
        <span v-if="bargainPriced" class="mypage-select-plan-button-parts__title-attention">{{
          bargainPriced
        }}</span>
        <span v-if="note" class="mypage-select-plan-button-parts__title-memo">{{ note }}</span>
      </span>
      <span class="mypage-select-plan-button-parts__price">
        <span class="mypage-select-plan-button-parts__price-data">{{ priceForButton }}</span>
        <span v-if="unit" class="mypage-select-plan-button-parts__price-unit">/{{ unit }}</span>
      </span>
    </span>
    <span v-if="period" class="mypage-select-plan-button-parts__period"
      >{{ $tc('MypagePage.MypageSwitchToPaidPlanPage.plans.period') }}{{ period }}</span
    >
  </button>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'
import I18n from '@/locales/I18n'

export default defineComponent({
  name: 'MypageSelectPlanButtonParts',
  props: {
    /**
     * 商品名
     */
    name: {
      type: String,
      default: '',
    },
    /**
     * 価格
     */
    price: {
      type: String,
      default: '',
    },
    /**
     * 価格（ボタンに表示する用）
     */
    priceForButton: {
      type: String,
      default: '',
    },
    /**
     * 支払い単位（サイクル）
     */
    unit: {
      type: String,
      default: '',
    },
    /**
     * お得額
     */
    bargainPriced: {
      type: String,
    },
    /**
     * 12で割った年額プランの価格
     */
    annualPlanPriceDividedBy12: {
      type: String,
    },
    /**
     * ノート
     */
    note: {
      type: String,
    },
    /**
     * 契約期間
     */
    period: {
      type: String,
      default: '',
    },
    /**
     * トライアルかどうか
     */
    isEligibleTrialPlan: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const handleClicked = () => {
      emit('onClick')
    }

    const priceShowOnTrial = computed(() => {
      if (props.annualPlanPriceDividedBy12) {
        // 年額プランの場合の処理
        return I18n.t('MypagePage.MypageSwitchToPaidPlanPage.plans.annual.priceShowOnTrial', {
          price: props.price,
          priceDividedBy12: props.annualPlanPriceDividedBy12,
        }).toString()
      }

      // 月額プランの場合の処理
      return I18n.t('MypagePage.MypageSwitchToPaidPlanPage.plans.monthly.priceShowOnTrial', {
        price: props.price,
      }).toString()
    })

    return {
      handleClicked,
      priceShowOnTrial,
    }
  },
})
</script>

<style scoped lang="scss">
.mypage-select-plan-button-parts {
  width: 100%;
  padding: 10px;
  border: 1px solid rgba(#000, 0.2);
  border-radius: 6px;

  &__header {
    display: flex;
    gap: 6px;
    align-items: center;
    justify-content: space-between;
  }

  &__title {
    display: flex;
    flex-direction: column;
    gap: 2px;

    &-name {
      display: block;
      font-size: 16px;
      font-weight: bold;
      letter-spacing: 0.02em;
      white-space: pre-wrap;
    }

    &-attention {
      display: inline-block;
      padding: 2px 5px;
      margin-top: 4px;
      font-size: 12px;
      font-weight: bold;
      color: $white;
      letter-spacing: 0.02em;
      background-color: $red;
      align-self: self-start;
    }

    &-price-show-on-trial {
      font-size: 10px;
      color: $black70;
      line-height: 1;
      margin-top: -2px;
      margin-bottom: 2px;
    }

    &-memo {
      font-size: 12px;
      font-weight: bold;
      color: rgba(#000, 0.5);
      letter-spacing: 0.02em;
      white-space: pre-wrap;
    }
  }

  &__price {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 156px;
    height: 40px;
    padding: 0 4px;
    color: $green;
    white-space: nowrap;
    background-color: $black;
    border-radius: 4px;

    &-data {
      font-size: 13px;
      font-weight: bold;
      letter-spacing: 0.04em;
    }

    &-unit {
      font-size: 12px;
      font-weight: bold;
      letter-spacing: 0.02em;
    }
  }

  &__period {
    display: block;
    height: 20px;
    padding-top: 2px;
    margin-top: 6px;
    font-size: 12px;
    font-weight: bold;
    color: $black50;
    letter-spacing: 0.02em;
    text-align: center;
  }

  &__start-trial-arrow {
    display: flex;
    margin-left: 4px;
    transform: translateY(-1px);
  }
}
</style>
